import { render, staticRenderFns } from "./question-type-select.vue?vue&type=template&id=0568b256"
import script from "./question-type-select.vue?vue&type=script&lang=js"
export * from "./question-type-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports